<div class="content">
  <div class="row items-push">
    <div class="col-sm-12 text-left">
      <ol class="breadcrumb push-10-t">
        <li><a [routerLink]="['/']">Inicio</a></li>
        <li><a class="link-effect" [routerLink]="['/solicitudes-engie']">Mis Solicitudes</a></li>
        <li><span class="link-effect">Registrar</span></li>
      </ol>
    </div>
  </div>
</div>
<div class="content">
  <div class="block">
    <div class="block-header">
      <h3 class="block-title">Registrar Solicitud</h3>
    </div>

    <form #modelForm="ngForm" (ngSubmit)="onSubmit(modelForm)" appIdentityRevealed>

      <div class="block-content">
        <app-solicitud-master [model]="model" [disabled]="false"
          (tipoVisitaEventChanged)="getConfiguracionDocumentosPorTipoVisita($event)"></app-solicitud-master>
      </div>
      <div class="block-content">
        <div class="form-horizontal">
          <mat-divider class="engie-divider"></mat-divider>
        </div>

        <mat-tab-group *ngIf="model.idTipoVisitaSelected">

          <mat-tab label="Personal">
            <div class="form-horizontal">
              <div class="form-group">
                <div class="col-sm-12 text-right">
                  <button type="button" class="btn btn-new" mat-raised-button
                    (click)="openDialogTipoDocumento(seccionPersonal)"><mat-icon>description</mat-icon> Agregar
                    Documento</button>

                </div>
              </div>
            </div>
            <div class="table-responsive">
              <table mat-table [dataSource]="model.lista_documentos_personal" class="table table-striped table-vcenter">
                <ng-container matColumnDef="nombre">
                  <th mat-header-cell *matHeaderCellDef>Documento</th>
                  <td mat-cell *matCellDef="let element">{{ element.documento }}</td>
                </ng-container>

                <ng-container matColumnDef="requisito">
                  <th mat-header-cell *matHeaderCellDef>Requisito</th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    <ng-container *ngIf="element.esRequisitoBloqueado">{{textoTodos}}</ng-container>
                    <!-- {{i}} -->
                    <mat-select name="documento_personal_{{i}}" matSelect [(ngModel)]="element.idRequisito"
                      *ngIf="!element.esRequisitoBloqueado">
                      <mat-option *ngFor="let item of listaTipoRequisitos; index as i"
                        [value]="item.idParametroDetalle">{{ item.valor }}</mat-option>
                    </mat-select>
                  </td>
                </ng-container>

                <ng-container matColumnDef="restringeAcceso">
                  <th mat-header-cell *matHeaderCellDef>Restringe Acceso</th>
                  <td mat-cell *matCellDef="let element">
                    <ng-container *ngIf="element.restringeAccesos">SI</ng-container>
                    <ng-container *ngIf="!element.restringeAccesos">NO</ng-container>
                  </td>
                </ng-container>

                <ng-container matColumnDef="acciones">
                  <th mat-header-cell *matHeaderCellDef>Acciones</th>
                  <td mat-cell *matCellDef="let element">
                    <button mat-icon-button color="primary" aria-label="Eliminar" (click)="deletePersona(element)"
                      *ngIf="!element.restringeAccesos">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
              </table>

            </div>

          </mat-tab>
          <mat-tab label="Equipos">
            <div class="form-horizontal">
              <div class="form-group">
                <div class="col-sm-12 text-right">
                  <a class="btn btn-new" mat-raised-button
                    (click)="openDialogTipoDocumento(seccionEquipos)"><mat-icon>description</mat-icon> Agregar
                    Documento</a>

                </div>
              </div>
            </div>
            <div class="table-responsive" class="table table-striped table-vcenter">
              <table #tableEquipos mat-table [dataSource]="model.lista_documentos_equipos"
                class="table table-striped table-vcenter">
                <ng-container matColumnDef="nombre">
                  <th mat-header-cell *matHeaderCellDef>Documento</th>
                  <td mat-cell *matCellDef="let element">{{ element.documento }}</td>
                </ng-container>

                <ng-container matColumnDef="requisito">
                  <th mat-header-cell *matHeaderCellDef>Requisito</th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    <ng-container *ngIf="element.esRequisitoBloqueado">{{textoTodos}}</ng-container>
                    <mat-select name="documento_equipo_{{i}}" matSelect [(ngModel)]="element.idRequisito"
                      *ngIf="!element.esRequisitoBloqueado">
                      <mat-option *ngFor="let item of listaTipoRequisitos; index as i"
                        [value]="item.idParametroDetalle">{{ item.valor }}</mat-option>
                    </mat-select>
                  </td>
                </ng-container>

                <ng-container matColumnDef="restringeAcceso">
                  <th mat-header-cell *matHeaderCellDef>Restringe Acceso</th>
                  <td mat-cell *matCellDef="let element">
                    <ng-container *ngIf="element.restringeAccesos">SI</ng-container>
                    <ng-container *ngIf="!element.restringeAccesos">NO</ng-container>
                  </td>
                </ng-container>

                <ng-container matColumnDef="acciones">
                  <th mat-header-cell *matHeaderCellDef>Acciones</th>
                  <td mat-cell *matCellDef="let element">
                    <button mat-icon-button color="primary" aria-label="Eliminar" (click)="deleteEquipo(element)"
                      *ngIf="!element.restringeAccesos">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
              </table>
            </div>
          </mat-tab>

          <mat-tab label="Vehiculos">
            <div class="form-horizontal">
              <div class="form-group">
                <div class="col-sm-12 text-right">
                  <a class="btn btn-new" mat-raised-button
                    (click)="openDialogTipoDocumento(seccionVehiculos)"><mat-icon>description</mat-icon> Agregar
                    Documento</a>
                </div>
              </div>
            </div>
            <div class="table-responsive" class="table table-striped table-vcenter">
              <table #tableVehiculos mat-table [dataSource]="model.lista_documentos_vehiculos"
                class="table table-striped table-vcenter">
                <ng-container matColumnDef="nombre">
                  <th mat-header-cell *matHeaderCellDef>Documento</th>
                  <td mat-cell *matCellDef="let element">{{ element.documento }}</td>
                </ng-container>

                <ng-container matColumnDef="requisito">
                  <th mat-header-cell *matHeaderCellDef>Requisito</th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    <ng-container *ngIf="element.esRequisitoBloqueado">{{textoTodos}}</ng-container>
                    <mat-select name="documento_vehiculo_{{i}}" matSelect [(ngModel)]="element.idRequisito"
                      *ngIf="!element.esRequisitoBloqueado">
                      <mat-option *ngFor="let item of listaTipoRequisitos; index as i"
                        [value]="item.idParametroDetalle">{{ item.valor }}</mat-option>
                    </mat-select>
                  </td>
                </ng-container>

                <ng-container matColumnDef="restringeAcceso">
                  <th mat-header-cell *matHeaderCellDef>Restringe Acceso</th>
                  <td mat-cell *matCellDef="let element">
                    <ng-container *ngIf="element.restringeAccesos">SI</ng-container>
                    <ng-container *ngIf="!element.restringeAccesos">NO</ng-container>
                  </td>
                </ng-container>

                <ng-container matColumnDef="acciones">
                  <th mat-header-cell *matHeaderCellDef>Acciones</th>
                  <td mat-cell *matCellDef="let element">
                    <button mat-icon-button color="primary" aria-label="Eliminar" (click)="deleteVehiculo(element)"
                      *ngIf="!element.restringeAccesos">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
              </table>
            </div>
          </mat-tab>

          <mat-tab label="Documentación técnica">
            <div class="form-horizontal">
              <div class="form-group">
                <div class="col-sm-12 text-right">
                  <a class="btn btn-new" mat-raised-button
                    (click)="openDialogTipoDocumento(seccionDocumentacionTecnica)"><mat-icon>description</mat-icon>
                    Agregar Documento</a>
                </div>
              </div>
            </div>
            <div class="table-responsive" class="table table-striped table-vcenter">
              <table #tableDocumentacionTecnica mat-table [dataSource]="model.documentosTecnicos"
                class="table table-striped table-vcenter">
                <ng-container matColumnDef="nombre">
                  <th mat-header-cell *matHeaderCellDef>Documento</th>
                  <td mat-cell *matCellDef="let element">{{ element.documento }}</td>
                </ng-container>

                <ng-container matColumnDef="requisito">
                  <th mat-header-cell *matHeaderCellDef>Requisito</th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    <ng-container *ngIf="element.esRequisitoBloqueado">{{textoTodos}}</ng-container>
                    <mat-select name="documento_tecnico_{{i}}" matSelect [(ngModel)]="element.idRequisito"
                      *ngIf="!element.esRequisitoBloqueado">
                      <mat-option *ngFor="let item of listaTipoRequisitos; index as i"
                        [value]="item.idParametroDetalle">{{ item.valor }}</mat-option>
                    </mat-select>
                  </td>
                </ng-container>

                <ng-container matColumnDef="restringeAcceso">
                  <th mat-header-cell *matHeaderCellDef>Restringe Acceso</th>
                  <td mat-cell *matCellDef="let element">
                    <ng-container *ngIf="element.restringeAccesos">SI</ng-container>
                    <ng-container *ngIf="!element.restringeAccesos">NO</ng-container>
                  </td>
                </ng-container>

                <ng-container matColumnDef="acciones">
                  <th mat-header-cell *matHeaderCellDef>Acciones</th>
                  <td mat-cell *matCellDef="let element">
                    <button mat-icon-button color="primary" aria-label="Eliminar"
                      (click)="deleteDocumentoTecnico(element)" *ngIf="!element.restringeAccesos">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
              </table>
              <!-- <table mat-table [dataSource]="model.lista_vehiculos">
                <ng-container matColumnDef="marca">
                  <th mat-header-cell *matHeaderCellDef>Marca</th>
                  <td mat-cell *matCellDef="let element">{{ element.marca }}</td>
                </ng-container>
        
                <ng-container matColumnDef="modelo">
                  <th mat-header-cell *matHeaderCellDef>Modelo</th>
                  <td mat-cell *matCellDef="let element">{{ element.modelo }}</td>
                </ng-container>
        
                <ng-container matColumnDef="placa">
                  <th mat-header-cell *matHeaderCellDef>Placa</th>
                  <td mat-cell *matCellDef="let element">{{ element.placa }}</td>
                </ng-container>
        
                <ng-container matColumnDef="color">
                  <th mat-header-cell *matHeaderCellDef>Color</th>
                  <td mat-cell *matCellDef="let element">{{ element.color }}</td>
                </ng-container>
        
                <ng-container matColumnDef="anio">
                  <th mat-header-cell *matHeaderCellDef>Año</th>
                  <td mat-cell *matCellDef="let element">{{ element.anio }}</td>
                </ng-container>
        
                <ng-container matColumnDef="chofer">
                  <th mat-header-cell *matHeaderCellDef>Chofer</th>
                  <td mat-cell *matCellDef="let element">{{ element.chofer.nombres + ' ' + element.chofer.apellido_paterno + ' ' + element.chofer.apellido_materno }}</td>
                </ng-container>
              
                <ng-container matColumnDef="acciones">
                  <th mat-header-cell *matHeaderCellDef>Acciones</th>
                  <td mat-cell *matCellDef="let element"> 
                    <button mat-icon-button color="primary" aria-label="Editar" (click)="openDialogVehiculo(element)">
                      <mat-icon>create</mat-icon>
                    </button>
          
                    <button mat-icon-button color="primary" aria-label="Eliminar">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </td>
                </ng-container>
        
                <tr mat-header-row *matHeaderRowDef="displayedColumnsVehiculos"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsVehiculos"></tr>
                </table> -->
            </div>
          </mat-tab>

        </mat-tab-group>

        <div class="form-horizontal pad-25">
          <div class="form-group">
            <div class="col-sm-12 text-right">

              <button type="submit" class="btn btn-naranja" (click)="save()" mat-raised-button><mat-icon>save</mat-icon>
                Guardar</button>
              <!-- <button type="submit" id="btnGuardar" class="btn btn-celeste" (click)="save()">Guardar</button>
                  <button type="submit" id="btnEnviar" class="btn btn-celeste" (click)="submit()">Enviar</button> -->
              <button type="submit" class="btn btn-celeste" (click)="submit()"
                mat-raised-button><mat-icon>send</mat-icon> Enviar</button>
              <a class="btn btn-naranja2" mat-raised-button (click)="closed()"><mat-icon>exit_to_app</mat-icon>
                Salir</a>
            </div>
          </div>
        </div>
      </div>


      <!-- <input type="text" id="motivo" name="motivo" [(ngModel)]="model.motivo" #motivo="ngModel" required> -->
      <!-- <button type="submit" >SUBMIT</button> -->
      <!-- [disabled]="modelForm.invalid" -->
    </form>
  </div>
</div>

<!-- <form #modelForm="ngForm" appIdentityRevealed>
  <input type="text" id="motivo" name="motivo" [(ngModel)]="model.motivo" #motivo="ngModel" required>
  <button type="submit" [disabled]="modelForm.invalid">SUBMIT</button>
</form> -->

<!-- <pre>{{ modelForm.invalid }}</pre>
<pre>{{ modelForm.dirty }}</pre> -->